import React, {useEffect, useContext, useState} from "react";
import { NavLink, Link } from 'react-router-dom';
import { AppContext } from "../../App.js";
          
//Import Css
import './panelMenuSlide.css';

//Import Assets
import LogoWebmedia from '../../assets/homeAssets/logoWebMedia.svg';

           
export function PanelMenuSlide() {

const {


    //State Barra Menu Down 
    visible,
    setVisible,
    //Menu Mobile Slide
    panelIsOpen,
    setPanelIsOpen


} = useContext(AppContext);


 

    return(
           
           
           /* --------- PANEL MENU SLIDE ----------- */
            <div className={`style-panel-menu-slide panel-menu-slide-${panelIsOpen ? 'open' : 'close'}`}>

                    <div className="box-logo-panel-slide">

                            <img className='logo-webmedia-panel-slide' src={LogoWebmedia} alt="Logo WebMedia"/>

                    </div>

                <nav className="conteiner-links-panel-slide">

                    <NavLink to='/desarrollo-web'        className={`home-menu-link slide-link-1`}>Desarrollo Web</NavLink>
                    <NavLink to='/google-ads'            className={`home-menu-link slide-link-2`}>Google ADS</NavLink>
                    <NavLink to='/email-marketing'       className={`home-menu-link slide-link-3`}>Email Marketing</NavLink>
                    <NavLink to='/soporte-empresas'      className={`home-menu-link slide-link-4`}>Soporte Empresas</NavLink>
                    <NavLink to='/contacto'              className={`home-menu-link slide-link-4`}>Contacto   </NavLink>

                </nav>

            </div>

    );

}